import React from 'react';

import css from './Step3DesktopContent.module.css';
import { ParsedFragmentEntity } from '@entities/ParsedFragment/Types';
import {
    ViewItemTypesModeEnum,
    ViewItemTypesModeType,
} from '@modules/Steps/Shared/Enums/ViewItemTypesModeEnum';
import { ItemTypeEntity } from '@entities/ItemType/Types';
import { StepContentElementWrapper } from '@modules/Steps/Shared/Ui/Wrappers/StepContentElementWrapper/StepContentElementWrapper';
import { CostSummaryHeaderStep3 } from '@modules/Steps/Shared/Widgets/CostSummaryHeaderStep3/CostSummaryHeaderStep3';
import { FragmentInfoStep3 } from '@modules/Steps/Components/Step3/Step3DesktopContent/FragmentInfoStep3/FragmentInfoStep3';
import { LaborAndToolsItemTypesInfoStep3 } from '@modules/Steps/Components/Step3/Step3DesktopContent/LaborAndToolsItemsTypesInfoStep3/LaborAndToolsItemTypesInfoStep3';
import { CustomProjectStep3ElementsIdsEnum } from '@modules/Steps/Shared/Enums/CustomProjectStep3ElementsIdsEnum';

interface Props {
    fragments: ParsedFragmentEntity[];
    fragmentsViewMode: ViewItemTypesModeType;
    laborItemTypes: ItemTypeEntity[];
    toolItemTypes: ItemTypeEntity[];
}

const Step3DesktopContent: React.FC<Props> = ({
    fragments,
    fragmentsViewMode,
    laborItemTypes,
    toolItemTypes,
}) => {
    const filteredFragments = fragments.filter(
        fragment =>
            fragment.itemTypes.length > 0 &&
            fragment.itemTypes.some(
                itemType =>
                    itemType.qty > 0 &&
                    itemType.items &&
                    itemType.items?.length > 0
            )
    );

    return (
        <div
            className={css.content}
            id={CustomProjectStep3ElementsIdsEnum.WORK_AREA_STEP3_SECTION}
        >
            <StepContentElementWrapper>
                <CostSummaryHeaderStep3 viewMode={fragmentsViewMode} />
                <div className={css.wrapper}>
                    {filteredFragments.map(fragment => (
                        <FragmentInfoStep3
                            key={fragment.uuid}
                            fragment={fragment}
                        />
                    ))}

                    {fragmentsViewMode ===
                        ViewItemTypesModeEnum.MaterialsLaborTools &&
                        laborItemTypes.length > 0 && (
                            <LaborAndToolsItemTypesInfoStep3
                                itemTypes={laborItemTypes}
                                title="Labour required for task (optional)"
                                description="Indicative labour costs for each section, not purchasable."
                                disabledButtons={true}
                            />
                        )}

                    {fragmentsViewMode ===
                        ViewItemTypesModeEnum.MaterialsLaborTools &&
                        toolItemTypes.length > 0 && (
                            <LaborAndToolsItemTypesInfoStep3
                                itemTypes={toolItemTypes}
                                title="Tools required for task (optional)"
                                description="You can select the tools you require, these are purchasable from the supplier you select."
                                disabledButtons={false}
                            />
                        )}
                </div>
            </StepContentElementWrapper>
        </div>
    );
};

export default React.memo(Step3DesktopContent);
